export const ACCESS_FEATURES_ACTION = {
    ACCESS_FEATURES_REQUEST: 'ACCESS_FEATURES_REQUEST',
    ACCESS_FEATURES_RESPONSE: 'ACCESS_FEATURES_RESPONSE',
    ACCESS_FEATURES_ERROR: 'ACCESS_FEATURES_ERROR'
  };
export const DATA_UPLOAD_TOGGLE_ACTION = {
    DATA_UPLOAD_TOGGLE_REQUEST: 'DATA_UPLOAD_TOGGLE_REQUEST',
    DATA_UPLOAD_TOGGLE_RESPONSE: 'DATA_UPLOAD_TOGGLE_RESPONSE',
    DATA_UPLOAD_TOGGLE_ERROR: 'DATA_UPLOAD_TOGGLE_ERROR'
  };
export const ACCESS_FEATURES_UPDATE_ACTION = {
    ACCESS_FEATURES_UPDATE_REQUEST: 'ACCESS_FEATURES_UPDATE_REQUEST',
    ACCESS_FEATURES_UPDATE_RESPONSE: 'ACCESS_FEATURES_UPDATE_RESPONSE',
    ACCESS_FEATURES_UPDATE_ERROR: 'ACCESS_FEATURES_UPDATE_ERROR'
  };